/* eslint-disable no-cond-assign */

import { ProposalDAOInterface } from '../ProposalDAO';
import { ComparisonItemBasedProposalDAO } from '../ProposalDAOImpl';
import { ProposalFieldDAO } from '../ProposalFieldDAO';
import * as ProposalNS from '../../Proposal';
import * as ProposalElementNS from '../../ProposalElements';
import { DataPoints, DataPointResponse } from '../DataPoints';
import { CREDIT_QUALITY_CATEGORIES, DISPLAYED_CREDIT_QUALITY_CATEGORIES, ASSET_ALLOCATION_GROUPS } from '../../../../utils/constants';
import { ComparisonItemDAO } from '../ProposalItemDAO';
import { PROPOSAL_DISCLAIMERS } from '../../utils/constants';
import { ProposalStyleClassNames } from '../../ProposalStyleClassNames';
import { NotApplicableCell, PercentageCell } from '../../../../views/components/cells';

export default class CreditQualityDAO extends ComparisonItemBasedProposalDAO {
  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    return new CreditQualityDAO(proposal, proposalElement);
  }

  /* eslint-disable-next-line class-methods-use-this */
  protected getColorKeys(): string[] {
    return ['CREDIT_RATING_COLORS'];
  }

  // eslint-disable-next-line class-methods-use-this
  private hasEmptyCredit(itemDAO: ComparisonItemDAO) {
    const equityAllocation = DataPoints.getAssetAllocationTotalsByCategory(itemDAO.item, ASSET_ALLOCATION_GROUPS.FIXED_INCOME).response;
    return equityAllocation > 0 && itemDAO.item.allocations && itemDAO.item.allocations.creditQuality && itemDAO.item.allocations.creditQuality.length === 0;
  }

  protected build(): void {
    const daoConfig: ProposalNS.CreditQualityConfig = this.proposalElement.DAO as ProposalNS.CreditQualityConfig;

    let itemDAO: ComparisonItemDAO | null = null;
    while ((itemDAO = this.nextItem()) !== null) {
      let qualityKeys: string[] = Object.keys(CREDIT_QUALITY_CATEGORIES).filter(category => category !== CREDIT_QUALITY_CATEGORIES.BELOW_B);

      if (daoConfig.groupBelowB) {
        qualityKeys = DISPLAYED_CREDIT_QUALITY_CATEGORIES;
      }

      for (const key of qualityKeys) {
        const dpResponse: DataPointResponse<number | undefined> = DataPoints.getCreditQualityAllocationByKey(itemDAO.item, key);
        let fieldName: string = this.formatMessage(`Comparison.Table.CreditQuality.${key}`);

        if (daoConfig.rollIntoNotRated && this.hasEmptyCredit(itemDAO) && key.toUpperCase() === CREDIT_QUALITY_CATEGORIES.NOT_RATED.toUpperCase()) {
          dpResponse.response = 100;
          this.addDisclaimerKeys([PROPOSAL_DISCLAIMERS.ROLL_INTO_NOT_RATED], itemDAO.item);
          fieldName += '*';
        }

        const value: number | undefined = dpResponse.response;

        const field = new ProposalFieldDAO(fieldName, value !== undefined ? value.toFixed(2) : 0, ProposalStyleClassNames.ProposalTableContent);
        field.cellType = value === undefined ? NotApplicableCell : PercentageCell;
        field.key = key;

        this.addDisclaimerKeys(dpResponse.disclaimerKeys, itemDAO.item);
        this.addFieldDAO(itemDAO, field);

        if (daoConfig.rollIntoNotRated && key === CREDIT_QUALITY_CATEGORIES.NOT_RATED && value !== undefined && value > 0) {
          this.addDisclaimerKeys([PROPOSAL_DISCLAIMERS.ROLL_INTO_NOT_RATED], itemDAO.item);
        }

        const color = (this.colorsDict && this.colorsDict[key]) || undefined;
        this.addFieldName(fieldName, ProposalStyleClassNames.ProposalTableContent, color);
      }
    }
  }
}
